/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Error_Server_RestartingInputs */



/**
* | output |
* | --- |
* | "The server restarted. Please start voice mode again." |
*
* @param {Voice_Error_Server_RestartingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const voice_error_server_restarting = /** @type {((inputs?: Voice_Error_Server_RestartingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Error_Server_RestartingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Server wurde neu gestartet. Bitte starten Sie den Sprachmodus erneut.")
	return /** @type {LocalizedString} */ ("The server restarted. Please start voice mode again.")
});